import { createSlice } from "@reduxjs/toolkit";
import ServerRoutes from "../api/routes";
import { get, post } from "../api/http";

const initialState = {
  todos: {},
  todosError: null,
  todosLoading: false,
};

const _addTodo = (state, action) => {
  let editedTodos = { ...state.todos };
  if (action.payload?.todo?._id) {
    editedTodos[action.payload.todo._id] = action.payload.todo;
  } else {
    editedTodos[action.payload.id] = {
      ...action.payload.body,
      done: false,
      _id: action.payload.id,
      dateAdded: action.payload.dateAdded,
    };
  }
  state.todos = editedTodos;
};

const _setTodos = (state, action) => {
  state.todos = action.payload;
  state.todosLoading = false;
};

const _editTodo = (state, action) => {
  let editedTodos = { ...state.todos };
  for (const [key, value] of Object.entries(action.payload.body))
    editedTodos[action.payload._id][key] = value;
  state.todos = editedTodos;
};

const _deleteTodo = (state, action) => {
  let editedTodos = { ...state.todos };
  delete editedTodos[action.payload];
  state.todos = editedTodos;
};

const _actionStart = (state) => {
  state.todosLoading = true;
  state.todosError = null;
};

const _actionSuccess = (state) => {
  state.todosLoading = false;
  state.todosError = null;
};

const _actionFailed = (state, action) => {
  state.todosLoading = false;
  state.todosError = action.payload.error;
};

const todos = createSlice({
  name: "todos",
  initialState,
  reducers: {
    addTodo: _addTodo,
    setTodos: _setTodos,
    editTodo: _editTodo,
    deleteTodo: _deleteTodo,
    actionStart: _actionStart,
    actionFailed: _actionFailed,
    actionSuccess: _actionSuccess,
  },
});

const { reducer, actions } = todos;

const {
  setTodos,
  addTodo,
  editTodo,
  deleteTodo,
  actionStart,
  actionFailed,
  actionSuccess,
} = actions;

export default reducer;

export const getAllAdmin = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(
      ServerRoutes.Todos.getAllAdmin,
      {},
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setTodos(data));
  };
};

export const getAllAvivit = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(
      ServerRoutes.Todos.getAllAvivit,
      {},
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setTodos(data));
  };
};

export const getTalsCalls = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Todos.getTalsCalls,
      body,
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setTodos(data));
  };
};

export const getAllProducer = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(
      ServerRoutes.Todos.getAllProducer,
      {},
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setTodos(data));
  };
};

export const getAll = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(ServerRoutes.Todos.getAll, {});
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setTodos(data));
  };
};

export const cleanAll = () => {
  return async (dispatch) => {
    dispatch(setTodos({}));
  };
};

export const add = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(ServerRoutes.Todos.add, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(addTodo({ todo: data }));
    }
  };
};

export const editTal = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Todos.editTal,
      body,
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      return dispatch(actionSuccess());
    }
  };
};

export const edit = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Todos.edit + _id, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(
        editTodo({
          _id,
          body,
        }),
      );
    }
  };
};

export const setSchedule = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(
      ServerRoutes.Todos.setSchedule + _id,
      body,
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(editTodo({ _id, body }));
    }
  };
};

export const setBelogs = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(
      ServerRoutes.Todos.setBelogs + _id,
      body,
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(
        editTodo({
          _id,
          body,
        }),
      );
    }
  };
};

export const setDone = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(
      ServerRoutes.Todos.setDone + _id,
      body,
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(
        editTodo({
          _id,
          body,
        }),
      );
    }
  };
};

export const deleteF = (id) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Todos.delete, { id });
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(deleteTodo(id));
    }
  };
};

export const fetchScheduledTasks = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.SmsScheduled.date,
      body,
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    return dispatch(actionSuccess(data));
    // return { payload: data };
  };
};

export const deleteScheduledTask = (taskId) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.SmsScheduled.cancelById,
      { taskId },
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    return dispatch(actionSuccess(taskId));
  };
};

export const deleteOldScheduledTasks = (beforeDate) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.SmsScheduled.deleteOld,
      { beforeDate },
    );
    if (status !== 200 || !data.success)
      return dispatch(
        actionFailed({
          error:
            (data && data.message) || error || "שגיאה במחיקת תזמונים ישנים",
        }),
      );
    return dispatch(actionSuccess(data));
  };
};

export const updateScheduledTask = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.SmsScheduled.editById,
      body,
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    return dispatch(actionSuccess());
  };
};
